var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trawl-web-layout',{ref:"layout",attrs:{"navigation":_vm.navigation}},[_vm._l((_vm.slotKeys),function(item){return _c('template',{slot:item},[_vm._t(item)],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }